import { Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import {useParams } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2'
import RowRadioButtonsGroup from "../Common/RowRadioButtonsGroup";
import { SaveSubmitModal } from "./SaveSubmitModal";

export default function Survey() {
    let { usrData } = useParams();
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [params, setParams] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);  
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const [assessmentStatus, setAssessmentStatus] = useState('0');
    const [subject, setSubject] = useState();
    const [isLoading, setIsLoading] = useState(true)
    const [characterCount, setCharacterCount] = useState(0)
    const [assessmentConfig, setAssessmentConfig] = useState(null);
    const [show, setShow] = useState(false);
    const [isRater, setIsRater] = useState(false);
    const [showSplash, setShowSplash] = useState(true);
    const [competencyRanges, setCompetencyRanges] = useState([]);

    useEffect(()=>{
        if(usrData){
            getAssessmentDetails()
        }
    },[usrData])

    const getAssessmentDetails = async() => {
        await axios.get(`/api/getSurveyDetails?surveyData=${usrData}`)
        .then(async function (response) {
            let result = response.data;
            if(result.success){
                setQuestions(result.data.questions)
                const grouped = {};
                let start = 1;

                result.data.questions.forEach((item) => {

                    const competencyId = item.question.competencyId;

                    if(!grouped[competencyId]){
                        grouped[competencyId] = {
                            competencyId,
                            competencyName: item.question.competency?.name || '',
                            total: 0
                        };
                    }

                    grouped[competencyId].total++;
                });

                const ranges = [];

                Object.values(grouped).forEach((item) => {

                    const end = start + item.total - 1;

                    ranges.push({
                        ...item,
                        start,
                        end
                    });

                    start = end + 1;
                });

                setCompetencyRanges(ranges);
                setParams(result.data.params)
                setAssessmentConfig(result.data.assessment);
                getAssessmentAnswers(result.data.params);
                setSubject(result.data.subject)

                if(result.data.params.raterId && result.data.params.raterId !== result.data.params.subjectId){
                    setIsRater(true)
                }
            }
        })
    }

    const getAssessmentAnswers = async(params) => {
        await axios.get(`/api/getAssessmentAnswers?adminId=${params.adminId}&assessmentId=${params.assessmentId}&subjectId=${params.subjectId}&raterId=${params.raterId?params.raterId:params.subjectId}&isSelf=${params.raterId?'0':'1'}`)
        .then(async function (response) {
            let result = response.data;
            console.log("getAssessmentAnswers result==",result.data)
            if(result.success){  
                setAnswers(result.data)
                setAssessmentStatus(result.assessmentStatus)
                setIsLoading(false)
            }
        })
    }

    const currentCompetency = competencyRanges.find((item) =>
        currentIndex + 1 >= item.start &&
        currentIndex + 1 <= item.end
    );

    useEffect(()=>{
        
        setCurrentQuestion(questions[currentIndex])
        if(answers && answers[currentIndex]){            
            console.log('aaaaaaaaaaaaa',currentIndex)
            setValue(answers[currentIndex].answer)
            setCharacterCount(answers[currentIndex].answer.length)
        }
    },[currentIndex, questions, answers])

    const handleBack = () => {
        setError('')
        setCurrentIndex(currentIndex >= 1 ? currentIndex-1: currentIndex)
    }

    const getRatingOptions = () => {
        if (!assessmentConfig) return [];

        const scalePoint = Number(assessmentConfig.scalePoint);
        const measurementType = assessmentConfig.measurementType;

        const optionsMap = {
                5: {
                    Frequency:["Not Observed","Never","Rarely","Sometimes","Often","Always"],
                    Quality: ["Not Observed","Poor","Fair","Good","Very Good","Excellent"],
                    Agreement: ["Not Observed","Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"],
                    Proficiency: ["Not Observed","Novice","Beginner","Competent","Proficient","Expert"],
                    Demonstration: ["Not Observed","Not Demonstrated","Partially Demonstrated","Adequately Demonstrated","Fully Demonstrated","Exceptionally Demonstrated"]
                },
                7: {
                    Frequency: ["Not Observed","Never","Rarely","Occasionally","Sometimes","Frequently","Often","Always"],
                    Quality: ["Not Observed","Unsatisfactory","Needs Improvement","Adequate","Developing Strength","Effective","Highly Effective","Exceptional"],
                    Agreement:["Not Observed","Strongly Disagree","Disagree","Somewhat Disagree","Neutral","Somewhat Agree","Agree","Strongly Agree"],
                    Proficiency: ["Not Observed","Novice","Beginner","Developing","Competent","Proficient","Advanced","Expert"],
                    Demonstration: ["Not Observed","Not Demonstrated","Slightly Demonstrated","Partially Demonstrated","Adequately Demonstrated","Substantially Demonstrated","Fully Demonstrated","Exceptionally Demonstrated"]
                }
            };
            console.log("scalePoint:", scalePoint);
            console.log("measurementType:", measurementType);

        return optionsMap[scalePoint]?.[measurementType] || [];
    };    

    const handleNext = async( isSubmit = '') => {
        setError('')
        const data = {
            assessmentId: params.assessmentId,
            subjectId: params.subjectId,
            answerBy: params.raterId ? params.raterId : params.subjectId,
            questionId: currentQuestion && currentQuestion.questionId,
            answer: value,
            isSelf: params.raterId ? '0' : '1',
            submitted: isSubmit !== '' ? '1' : ''
        }
        console.log("data==",data);
        if(data.answer === ''){
            if(currentQuestion && currentQuestion.question.questionTypeId === 1){
                setError('Please select one of the options above')
                return false;
            }
            else{
                // setError('Please fill the answer')
            }
            
        }
        await axios.post(`/api/saveAssessmentAnswer`, data).then(async function (response) {
            let result = response.data;
            setValue('');
            if(result.success){
                if(isSubmit == ''){

                    const nextIndex = currentIndex + 1;

                    const currentCompetencyId =
                        questions[currentIndex]?.question?.competencyId;

                    const nextCompetencyId =
                        questions[nextIndex]?.question?.competencyId;

                    // competency change hui to splash screen show karo
                    if(currentCompetencyId !== nextCompetencyId){
                        setShowSplash(true);
                    }

                    setCurrentIndex(nextIndex);

                }
                else{
                    setShow(false)
                }

                getAssessmentAnswers(params)
            }
        })
    }

    const closeTab = () => {
        // alert('Please close this tab manually.');
        window.open("https://www.google.com", "_self");
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    };

    const openSaveSubmitModal = () => {
        setShow(true)
    }

    const capitalizeFirstLetter = (text) => {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    return(       
        <>
            <div className="RgCenterAlign">
                {
                    isLoading ?
                    <div className="loader-center">
                        <div className="spinner-border text-white" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    :
                    <>
                    <div className="card survey-card">
                        <div className="card-header border-0 text-center">
                            <div className="d-flex justify-content-between align-items-center">
                                <img src={assessmentConfig.logo1} className="logo img-fluid" alt="logo" style={{width: '200px'}}/>
                                <Link to='/'>
                                    <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} className="logo img-fluid" alt="logo" style={{width: '200px'}}/>
                                </Link>
                            </div>
                            {params.raterId && params.raterId !== params.subjectId ? <h4 className="text-center">Feedback for {subject.firstName}</h4> : ''}
                            {assessmentStatus === '1' ? '' : <h4 className="text-center">Question {currentIndex+1}/{questions.length}</h4>}
                        </div> 
                        {assessmentStatus === '1' ? 
                            <div className="card-body">
                                <div className="submitCheck">
                                    <img src={process.env.REACT_APP_BASE_URL+"assets/img/circle-check.gif"}/>
                                    <br></br><br></br>
                                    <h4>Thank you..<br/><br/>Your survey has been successfully submitted. You may now close your browser.</h4>
                                    {/* <button className="btn btn-primary" onClick={closeTab}>Finish and Close</button> */}
                                </div>
                            </div> 
                        :
                        <div className="card-body">
                            <hr/>
                            {
                                showSplash && currentCompetency ?
                                <div className="text-center py-5">
                                    <h5 className="mb-3">
                                        The following {currentCompetency.total} questions relate to {isRater ? subject.firstName+"'s" : 'your'} approach to {currentCompetency.competencyName}
                                    </h5>

                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        onClick={() => setShowSplash(false)}
                                    >
                                        Start
                                    </button>

                                </div>
                                :
                                <form method="POST" onKeyDown={(e) => checkKeyDown(e)}>
                                    { currentQuestion ?
                                            (currentQuestion.question.questionTypeId === 1 ? 
                                                <div className="row mb-5">                                            
                                                    <div className="col-md-12">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <h5 className="fw-semibold">
                                                                {
                                                                    capitalizeFirstLetter(
                                                                        params?.raterId
                                                                            ? currentQuestion?.question?.name
                                                                                ?.replace(/SUBJECT_FIRST_NAME/g, subject.firstName)
                                                                                ?.replace(/ORGANIZATION/g, subject.organization)
                                                                                ?.replace(/PRONOUN/g, subject.preferredPronoun)
                                                                            : currentQuestion?.question?.name
                                                                                ?.replace(/SUBJECT_FIRST_NAME's/g, 'your')
                                                                                ?.replace(/SUBJECT_FIRST_NAME/g, 'you')
                                                                                ?.replace(/SUBJECT_FIRST _NAME/g, 'you')
                                                                                ?.replace(/ORGANIZATION/g, subject.organization)
                                                                                ?.replace(/PRONOUN/g, 'your')
                                                                                ?.replace(/Does/g, 'Do')
                                                                                ?.replace(/does/g, 'do')
                                                                                ?.replace(/has/g, 'have')
                                                                                ?.replace(/Has/g, 'Have')
                                                                    )
                                                                }
                                                            </h5>
                                                            {/* <h4>{currentIndex+1}/{questions.length}</h4> */}
                                                        </div>
                                                        {/* <h5>{currentQuestion.question.name}</h5> */}
                                                        <div className="RgRating">                                                        
                                                            {/* <StarRatingStepper value={value} setValue={setValue} handleNext={handleNext}/> */}
                                                            <RowRadioButtonsGroup value={value} setValue={setValue} setError={setError} handleNext={handleNext} currentIndex={currentIndex} totalQuestions={questions.length} options={getRatingOptions()} params={params}/>
                                                        </div>                                                  
                                                    </div>
                                                </div>
                                            :
                                            <div className="row mb-5">
                                                <div className="col-md-12">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h5 className="fw-semibold" style={{marginBottom: 0}}>
                                                            {
                                                                capitalizeFirstLetter(
                                                                    params?.raterId
                                                                        ? currentQuestion?.question?.name
                                                                            ?.replace(/SUBJECT_FIRST_NAME/g, subject.firstName)
                                                                            ?.replace(/ORGANIZATION/g, subject.organization)
                                                                            ?.replace(/PRONOUN/g, subject.preferredPronoun)
                                                                        : currentQuestion?.question?.name
                                                                            ?.replace(/SUBJECT_FIRST_NAME's/g, 'your')
                                                                            ?.replace(/SUBJECT_FIRST_NAME/g, 'you')
                                                                            ?.replace(/SUBJECT_FIRST _NAME/g, 'you')
                                                                            ?.replace(/ORGANIZATION/g, subject.organization)
                                                                            ?.replace(/PRONOUN/g, 'your')
                                                                            ?.replace(/Does/g, 'Do')
                                                                            ?.replace(/does/g, 'do')
                                                                            ?.replace(/has/g, 'have')
                                                                            ?.replace(/Has/g, 'Have')
                                                                )
                                                            }
                                                        </h5>                                                    
                                                    </div>
                                                    {/* <h5>{currentQuestion.question.name}</h5> */}
                                                    <p style={{textAlign: 'right', marginBottom: 0}}>{characterCount}/1500</p>
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        placeholder="Enter your response"
                                                        onChange={(e) => {
                                                            setValue(e.target.value);
                                                            setError('')
                                                            setCharacterCount(e.target.value.length)
                                                        }}
                                                        maxLength={1500}
                                                        value={value}
                                                    />                                                  
                                                </div>
                                            </div>)                                
                                        :''
                                    }  
                                    <span className="text-danger">{error?error:''}</span>                           
                                    <hr/>
                                    <div className={currentIndex < questions.length-1 && currentQuestion.question.questionTypeId === 1 ? "d-flex justify-content-between align-items-center" : ""}>
                                        {/* {
                                            currentIndex < questions.length-1 && currentQuestion.question.questionTypeId === 1 ?
                                                <div className="text-warning">Once you have selected an option you will automatically move to the next question</div>
                                            : ''
                                        } */}
                                        {/* <div></div> */}
                                        <div className={"d-flex"}>
                                            {
                                                currentIndex > 0 ?
                                                    <button type="button" className="btn btn-outline-secondary me-4" onClick={handleBack}><span className="bi bi-chevron-left"></span>&nbsp; Back </button>
                                                :"" 
                                            }

                                            { 
                                            currentIndex < questions.length-1 ?
                                                <button type="button" className="btn btn-primary" onClick={() =>{ handleNext('')} }> Next &nbsp; <span className="bi bi-chevron-right"></span></button>
                                            :
                                                (currentIndex === questions.length-1 ? <button type="button" className="btn btn-primary"  onClick={() => {openSaveSubmitModal()}}> Save & Submit</button> : "")
                                            }
                                        </div>
                                    </div>
                                    
                                </form>
                            }
                        </div> 
                        }                                    
                    </div>
                    <SaveSubmitModal show={show} setShow={setShow} handleNext={handleNext} isRater={isRater} subjectName={subject.firstName}/>
                    </>
                }
            </div>
        </>
    )
}